import React from "react";
import { Link } from "react-router-dom";
import { Home, Mail } from "lucide-react";
import { useCountry } from "../../contexts/CountryContext";

const Footer = () => {
  const { country } = useCountry();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="logo-icon">
                <Home size={20} />
              </div>
              <span className="logo-text"><span className="logo-handy">Handy</span><span className="logo-hub">Hub</span></span>
            </div>
            <p className="footer-desc">
              Your trusted marketplace for carefully reviewed local service professionals,
              proudly run by an {country.teamLabel} serving {country.marketingRegion}.
            </p>
          </div>
          <div className="footer-section">
            <h4>Popular Categories</h4>
            <Link to="/categories/home-cleaning">Home Cleaning</Link>
            <Link to="/categories/plumbing">Plumbing</Link>
            <Link to="/categories/electrical">Electrical</Link>
            <Link to="/categories/handyman">Handyman</Link>
            <Link to="/categories" className="footer-view-all">View All Categories</Link>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/join-as-pro">Join as Pro</Link>
            <Link to="/faq">FAQ</Link>
          </div>
          <div className="footer-section">
            <h4>Legal</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/cancellation-policy">Cancellation Policy</Link>
            <Link to="/provider-agreement">Provider Agreement</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-disclaimer" data-testid="footer-disclaimer">
            HandyHub reviews provider information during onboarding, however customers should independently assess providers before engaging services.
          </p>
          <p data-testid="footer-support-line" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', flexWrap: 'wrap', marginBottom: '6px' }}>
            <Mail size={12} aria-hidden="true" />
            <a href={`mailto:${country.supportEmail}`} style={{ color: 'inherit' }} data-testid="footer-support-email">
              {country.supportEmail}
            </a>
          </p>
          <p>&copy; {new Date().getFullYear()} HandyHub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export { Footer };
